
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import type { Level2CourseUIType } from '@xt/client/utils/activities/types.d.ts'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class Courses extends Mixins(MixinsHomeClick) {
  @Prop({ default: () => [] }) readonly courses!: Array<Level2CourseUIType>

  handleClick(item: Level2CourseUIType) {
    if (item.event) {
      this.onClickEvent(item.event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
